import { ApiFormattedResponse } from "@models/api_formatted_response"
import {
  InspectCollectionInput,
  InspectCollectionResult,
  MigrationRun
} from "@pages/main/scripts/migrations/migration.models"
import { mutate, query } from "@utils/graphql"
import startMigrationDoc from "__generated__/queries/mutations/startMigration"
import getMigrationHistoryDoc from "__generated__/queries/queries/getMigrationHistory"
import getMigrationLatestRunsDoc from "__generated__/queries/queries/getMigrationLatestRuns"
import inspectCollectionDoc from "__generated__/queries/queries/inspectCollection"

type Envelope<T> = {
  success?: boolean | null
  data?: T | null
  code?: string | null
  message?: string | null
}

export async function inspectCollection(
  data: InspectCollectionInput
): Promise<ApiFormattedResponse<Envelope<InspectCollectionResult>>> {
  const response = await query<
    { inspectCollection: Envelope<InspectCollectionResult> },
    { data: InspectCollectionInput }
  >({
    query: inspectCollectionDoc,
    variables: { data },
    fetchPolicy: "network-only"
  })
  return { ...response, data: response.data?.inspectCollection }
}

export async function getMigrationLatestRuns(): Promise<
  ApiFormattedResponse<Envelope<MigrationRun[]>>
> {
  const response = await query<{
    getMigrationLatestRuns: Envelope<MigrationRun[]>
  }>({ query: getMigrationLatestRunsDoc, fetchPolicy: "network-only" })
  return { ...response, data: response.data?.getMigrationLatestRuns }
}

export async function getMigrationHistory(
  type: string
): Promise<ApiFormattedResponse<Envelope<MigrationRun[]>>> {
  const response = await query<
    { getMigrationHistory: Envelope<MigrationRun[]> },
    { type: string }
  >({
    query: getMigrationHistoryDoc,
    variables: { type },
    fetchPolicy: "network-only"
  })
  return { ...response, data: response.data?.getMigrationHistory }
}

/** Returns the RUNNING row at once; the run carries on server-side and is polled via latest runs. */
export async function startMigration(
  type: string,
  probe: InspectCollectionInput
): Promise<ApiFormattedResponse<Envelope<MigrationRun>>> {
  const response = await mutate<
    { startMigration: Envelope<MigrationRun> },
    { type: string; probe: InspectCollectionInput }
  >({ mutation: startMigrationDoc, variables: { type, probe } })
  return { ...response, data: response.data?.startMigration }
}
